// extracted by mini-css-extract-plugin
export default {"regulationContainer":"Statute_regulationContainer__u1haf","regulationText":"Statute_regulationText__6VzM8","sectionNumber":"Statute_sectionNumber__clVHv"};